<template>
	<div class="know">
		<div class="flex">
			<div class="title">出版社</div>
      <el-button
        class="new-create"
        icon="el-icon-edit"
        @click="editVisible = !editVisible"
        v-if="
          $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
          ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP5111_${yy_ms}_3`]))
        "
        >{{ editVisible ? '退出' : '编辑' }}</el-button
      >
			<!-- <el-button class="new-create" icon="el-icon-plus" @click="dialogVisible = true">增加分类</el-button> -->
		</div>
		<div class="point">
			<div
				class="point-header"
        _flex="~ justify-center items-center"
				v-if="
					$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
					($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP5111_${yy_ms}_1`]))
				"
			>
        <InputTopTip v-model="inputValue" placeholder="输入新的出版社，回车添加" :marginTop="10">
          <el-input
            class="point-header-input"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm(inputValue)"
            placeholder=""
            @input="e => inputValue = e.replace(/\s/g, '')"
          >
          </el-input>
            <!-- prefix-icon="el-icon-plus" -->
        </InputTopTip>
        <div _flex="1" _cursor="pointer" _h="30px" @click="isExpand = !isExpand"></div>
        <i
          class="el-icon-arrow-up"
          _transition="duration-300"
          _transform="~ gpu"
          _cursor="pointer"
          @click="isExpand = !isExpand"
          :class="[isExpand ? 'w-rotate-[0deg]' : 'w-rotate-[180deg]']"
        />
			</div>
			<div class="point-context" :style="{
        height: isExpand ? 'auto' : '0px',
        minHeight: isExpand ? '40px' : '0px',
        padding: isExpand ? '0 11px 13px' : '0px 0px',
        overflowY: isExpand ? 'auto' : 'hidden'
      }">
        <el-tooltip v-for="(element) in tags" :key="element.id" effect="light" :content="element.name" placement="top">
          <el-tag
            :key="'tag_' + element.id"
            class="tag"
            type="info"
            :closable="
              editVisible && (
                $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
                ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP5111_${yy_ms}_2`]))
              )
            "
            :style="{ cursor: editVisible ? 'pointer' : 'default' }"
            @click="handleClick(element.name, element.id)"
            @close="handleClose(element.id, index)">
            {{ element.name.length >= 20 ? element.name.substring(0, 20) + '...' : element.name }}
          </el-tag>
        </el-tooltip>
      </div>
		</div>
    <el-dialog
			title="修改出版社名称"
			:visible.sync="editNameVisible"
			width="30%"
			class="dialog"
			:before-close="beforeClose"
			:close-on-click-modal="false"
		>
      <InputTopTip v-model="editName" placeholder="出版社名称" :marginTop="14" class="dialog-input">
        <el-input v-model="editName" placeholder=""></el-input>
      </InputTopTip>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="editNameVisible = false" :disabled="loading">取 消</el-button>
				<el-button size="small" type="primary" @click="confirmClick" :loading="loading">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
			tags: [],
			inputValue: '',
			classValue: '',
			loading: false,
      sbid: '',
      isExpand: false,
      editVisible: false,
      editNameVisible: false,
      editName: '',
      editId: null
		}
	},
	async mounted() {
		const { sbid } =this.$route.params
    this.sbid = sbid
		await this.getPublisherId()
    if (this.$store.state.user.userInfo.type === this.$api.account.types.OTHER.value) {
      if (!this.$permissions([`SP5111_${this.yy_ms}_1`])) {
        this.isExpand = true
      }
    }
    if (this.$store.state.user.userInfo.type === this.$api.account.types.TEACHER.value) {
      this.isExpand = true
    }
    if (this.$store.state.user.userInfo.type === this.$api.account.types.SCHOOL_ADMIN.value) {
      this.isExpand = true
    }
	},
  computed: {
		yy_ms() {
			return this.sbid == 1 ? 'yy' : this.sbid == 2 ? 'ms' : ''
		}
	},
  watch: {
    editVisible: {
      handler(val) {
        if (!val) {
          this.getPublisherId()
        }
      }
    }
  },
	methods: {
    handleClick(knowledge_name, id) {
      if (!this.editVisible) return
      this.editName = knowledge_name
      this.editId = id
      this.editNameVisible = true
    },
    async editNameEvent(knowledge_name, id) {
      try {
				await this.$api.question_set.updatePublisherId(id, {
          name: knowledge_name,
          subject_id: this.sbid
        })
        this.$message.success('出版社信息更新成功')
			} catch (err) {
        console.error(err)
			} finally {
        this.getPublisherId()
      }
    },
		async getPublisherId() {
			const { data } = await this.$api.question_set.getPublisherId({
        fb_subject_id: this.sbid
      })
			this.tags = data
		},
		async beforeClose(done) {
			if (this.loading) return
			done()
		},
		async confirmClick() {
			this.loading = true
			await this.editNameEvent(this.editName, this.editId)
			this.loading = false
			this.editNameVisible = false
		},
		async handleClose(id, index) {
      await this.$confirm('是否删除该出版社信息？', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					try {
            await this.deletePublisherId(id)
            this.tags.splice(index, 1)
            this.$message.success('删除成功')
          } catch (err) {
            this.getPublisherId()
          }
				})
				.catch(() => {})
		},
		async handleInputConfirm(knowledge_name) {
      if (!knowledge_name) return
      if (this.loading) return
			try {
        this.loading = true
				await this.$api.question_set.addPublisherId({
					name: knowledge_name,
          subject_id: this.sbid
				})
				this.inputValue = ''
				this.getPublisherId()
        this.loading = false
			} catch (err) {
				this.getPublisherId()
        this.loading = false
			}
      this.isExpand = true
		},
		async deletePublisherId(id) {
			await this.$api.question_set.deletePublisherId(id, {})
		}
	}
}
</script>
<style lang="scss" scoped>
.know {
	background: #ffffff;
	border-radius: 12px;
	// padding: 21px;
	margin: 5px;
	padding: 16px;
	border: 2px solid #f5f5fb;
}
.flex {
	display: flex;
	justify-content: space-between;
}
.new-create {
	width: 111px;
	height: 33px;
	line-height: 33px;
	background: #f5f5fb;
	border-radius: 4px 4px 4px 4px;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
}
.dialog {
	/deep/ .el-dialog__title {
		font-size: 18px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #323232;
	}
	/deep/ .el-dialog__body {
		border-top: 2px solid #f8f8f8;
		border-bottom: 2px solid #f8f8f8;
		margin: 1px 20px;
	}
	/deep/ .el-dialog__footer {
		margin-top: 24px;
		margin-bottom: 25px;
	}
}

.dialog-input {
	margin: 38px 0;
}
.title {
	font-size: 20px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: bold;
	color: #3e3e3e;
	margin-bottom: 29px;
}
.subtitle {
	font-size: 16px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #737373;
	margin-bottom: 16px;
}
.point {
	border: 1px #ffffff solid;
	background: #f9fbff;
	margin-bottom: 24px;
}
.point-header {
	border-bottom: 1px #ffffff solid;
	padding: 6px 12px;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	border: 2px solid #f5f5fb;
}
.point-context {
	display: flex;
	flex-wrap: wrap;
	align-content: flex-start;
	padding: 11px 13px;
	background: #f9fbff;
	// min-height: 199px;
	border-radius: 6px 6px 6px 6px;
  position: relative;
  overflow-x: hidden ;
}
.point-header-input {
	width: 213px;
	background: #f5f7fa;
	border-radius: 4px 4px 4px 4px;
}
.tag {
	// height: 30px;
	background: #e4e8f8;
	border-radius: 4px 4px 4px 4px;
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #494949;
	margin-right: 30px;
	margin-top: 8px;
}
.input-new-tag {
  margin-top: 10px;
  margin-right: 30px;
  vertical-align: bottom;
}

.slide-fade-enter {
  // position: absolute;
	transition: all 0.3s ease;
	transform: translateX(0);
	opacity: 1;
}

.slide-fade-leave {
  // position: absolute;
  content-visibility: hidden;
	transition: all 0.3s ease;
	transform: translateX(100px);
	opacity: 0;
}
</style>
